import React, { useContext } from 'react';
import './RoomsHeader.css';
import { LanguageContext } from '../context/LanguageContext';


const RoomsHeader = () => {
  const {t} = useContext(LanguageContext);
  return (
    <section className="rooms-header">
      <h1 className="rooms-header-title">{t("rooms", "title")}</h1>
      <p className="rooms-header-description">
        {t("rooms", "subtitle")}
      </p>
    </section>
  );
};

export default RoomsHeader;